import { NoteChip } from "@/components/chips/note-chip";
import { MdsItemListRowFeaturedContent } from "@/design-system/components/item-list/rows/MdsItemListRowFeaturedContent";
import { sortCollectionsForChips } from "@/domains/collections/sortCollectionsForChips";
import { INoteObservable } from "@/store/note";
import { truncate } from "lodash-es";
import styled from "@emotion/styled";
import { generateRelativePrepositionAdverbialDateString } from "@/domains/date/date";
import {
  MDSDialogHeaderContent,
  MDSDialogSlotName,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  note: INoteObservable;
}

export const AboutNoteModal = ({ isOpen, onClose, note }: Props) => {
  const collections = note?.collectionList?.allCollections || [];
  const hasCollections = collections.length > 0;

  return (
    <MDSModalDialog isOpen={isOpen} handleClose={onClose}>
      <MDSDialogHeaderContent slot={MDSDialogSlotName.Header} allowOverflow={false}>
        <MDSText variant={MDSTextVariant.HeaderS} weight={MDSTextWeight.Bold}>
          About
        </MDSText>
        <NoteChip title={truncate(note.title, { length: 50 })} />
      </MDSDialogHeaderContent>

      <StyledDialogContent slot={MDSDialogSlotName.Content}>
        <MetaData
          label="Created by"
          value={`${note.primaryOwner?.profileDisplayName} ${generateRelativePrepositionAdverbialDateString(note.locallyCreatedAt)}`}
        />
        {/* TODO: show who last edited this note when we have that data available
            <MetaData label="Last edited by" value={note.locallyModifiedAt} /> 
        */}
        {hasCollections ? (
          <MetaData
            label="Collections"
            value={
              <MdsItemListRowFeaturedContent
                collections={sortCollectionsForChips(collections)}
                itemId={note.id}
                showAll
              />
            }
          />
        ) : null}
      </StyledDialogContent>
    </MDSModalDialog>
  );
};

interface MetaDataProps {
  label: string;
  value: React.ReactNode;
}
const MetaData = ({ label, value }: MetaDataProps) => {
  return (
    <MetaDataWrapper>
      <MDSText variant={MDSTextVariant.TextS} weight={MDSTextWeight.Medium}>
        {label}
      </MDSText>
      <MDSText variant={MDSTextVariant.TextS}>{value}</MDSText>
    </MetaDataWrapper>
  );
};

const StyledDialogContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.sm};
  gap: ${({ theme }) => theme.spacing.md};
`;

const MetaDataWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing.xs,
}));
